#import "./TrainingModuleAdminFields.graphql"

mutation CreateTrainingModule(
  $moduleInput: TrainingModuleInput!
  $courseId: ID
) {
  createTrainingModule(
    input: { moduleInput: $moduleInput, courseId: $courseId }
  ) {
    trainingModule {
      ...TrainingModuleAdminFields
    }
  }
}
